<template>
    <v-select  
       :value="selected_bedrcodes"      
       v-model="selectedbedrcodes"
       v-bind:items="bedrcodes"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData()"
       v-on:click:clear="callClear()">
       <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                    <v-icon :color="selectedbedrcodes.length > 0 ? 'indigo darken-4' : ''"> {{ getIcon() }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.code }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selectedbedrcodes.length - visibleChips }})</span>
        </template>                                                        
     
    </v-select>
</template>

<script>
export default {
    props: {
        selected_bedrcodes: {
            type: Array,
            default: function() { return []; },
        },
        label: {
            type: String,
            default: 'Company'
        },   
        field: {
            default: 'bedrCodesSelected',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        },
        isDense: {
            type: Boolean,
            init: false
        },
        isMultiple:{
            type: Boolean,
            default: true
        },  
        visibleChips:{
            type: Number,
            default: 5
        },  
        localStorageItem:{
            type: String,
            default: 'search.acco.bedrcodes'
        }
    },          
    data() {
        return {
            bedrcodes: [],
            selectedbedrcodes: [],
        }
    },
    created() {
        this.getBedrCodes();
    },
    methods: {
        callClear(){
            this.selectedbedrcodes = [];
        },
        getIcon: function () {
            if (this.isAllSelected()) return 'mdi-close-box'
            if (this.isSomeSelected()) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },    
        isAllSelected: function () {
            return this.selectedbedrcodes.length === this.bedrcodes.length; 
        },
        isSomeSelected: function () {            
            return this.selectedbedrcodes.length > 0 && this.selectedbedrcodes.length !== this.bedrcodes.length;
        },   
        toggle() {
            this.$nextTick(() => {
                if (this.isAllSelected()) {
                    this.selectedbedrcodes = [];
                    this.updateData();
                } else {
                    this.selectAll();
                    this.updateData();
                }
            })
        },                 
        getBedrCodes() {
            this.$axios
                .post("ares/json/ares/huis/bedr/getBedr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getBedr"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        // console.log(res);
                        this.bedrcodes = res.data.getBedr;
                        if(localStorage.getItem(this.localStorageItem)!==null){
                           this.selectedbedrcodes=localStorage.getItem(this.localStorageItem).split(",");
                        } else {
                           this.selectAll();
                        }
                        this.updateData();
                    }
                })
        },
        selectAll(){
            this.selectedbedrcodes = [];
            this.bedrcodes.forEach(x => {
                this.selectedbedrcodes.push(x.code);
            });
        }, 
        updateData(){              
            this.$emit('updateData', { "field": this.field, "value": this.selectedbedrcodes })
        } 
    }
}
</script>

<style scoped>

</style>